import { render, staticRenderFns } from "./ui-date.vue?vue&type=template&id=bd80d72a&scoped=true&"
import script from "./ui-date.vue?vue&type=script&lang=js&"
export * from "./ui-date.vue?vue&type=script&lang=js&"
import style0 from "./ui-date.vue?vue&type=style&index=0&id=bd80d72a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd80d72a",
  null
  
)

export default component.exports